import { useEffect, useCallback, useState } from 'react'

export const useTimeExpiration = (time, key) => {
  const [isExpired, setIsExpired] = useState(false)
  const [isStarted, setIsStarted] = useState(false)

  const addTimer = useCallback(() => {
    const expiresAt = Date.now() + time * 1000
    localStorage.setItem(key, String(expiresAt))
    setIsStarted(true)
    setIsExpired(false)
  }, [key, time])

  const checkTimer = useCallback(() => {
    const expirationTime = parseInt(localStorage.getItem(key), 10)
    if (expirationTime) {
      const currentTime = Date.now()
      if (currentTime > expirationTime) {
        setIsExpired(true)
        setIsStarted(false)
        localStorage.removeItem(key)
      }
    }
  }, [key])

  useEffect(() => {
    const interval = setInterval(() => {
      checkTimer()
    }, 1000)

    return () => clearInterval(interval)
  }, [checkTimer])

  useEffect(() => {
    const expirationTime = parseInt(localStorage.getItem(key), 10)
    if (expirationTime && Date.now() < expirationTime) {
      setIsStarted(true)
    }
  }, [key])

  return {
    addTimer,
    isExpired,
    isStarted
  }
}
